/* unplugin-vue-components disabled */import { render } from "./usage-reports.vue?vue&type=template&id=6b6f9e62&scoped=true"
import script from "./usage-reports.vue?vue&type=script&lang=js"
export * from "./usage-reports.vue?vue&type=script&lang=js"

import "./usage-reports.vue?vue&type=style&index=0&id=6b6f9e62&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6f9e62"],['__file',"src/pages/settings/analytics/usage-reports.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b6f9e62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b6f9e62', __exports__)) {
    api.reload('6b6f9e62', __exports__)
  }
  
  module.hot.accept("./usage-reports.vue?vue&type=template&id=6b6f9e62&scoped=true", () => {
    api.rerender('6b6f9e62', render)
  })

}


export default __exports__